import clsx from 'clsx'
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload'
import React from 'react'
import { useIntl } from 'react-intl'
import { formatBytes } from '../../../services/utils'
import DropzoneFileList from './DropzoneFileList'
import { useDropzoneContext } from '../../../contexts/DropzoneContext'
import DropzoneRejections from './DropzoneRejections'

const DropzoneContent = () => {
	const { formatMessage } = useIntl()

	const {
		error,
		helperText,
		maxFiles,
		maxSize,
		color,
		dropzoneState: { getRootProps, getInputProps, fileRejections },
	} = useDropzoneContext()
	return (
		<>
			<div
				className={clsx(
					'border-dashed border-2 rounded-lg cursor-pointer',
					color
				)}
			>
				<div {...getRootProps()} className="p-10">
					<input {...getInputProps()} />
					<div className="text-center">
						<div className="font-black">
							{formatMessage({ id: 'dropzone.instructions' })}
						</div>
						<DriveFolderUploadIcon fontSize="large" />
					</div>
				</div>
			</div>
			{(helperText || maxSize || maxFiles) && (
				<div
					className={clsx(
						'text-xs mt-1',
						error ? 'text-red-700' : undefined
					)}
				>
					<div>{helperText}</div>
					{(maxFiles || maxSize) && (
						<div>
							{maxFiles && (
								<span>
									{formatMessage(
										{ id: 'dropzone.up_to_files' },
										{
											size: maxFiles,
										}
									)}
								</span>
							)}
							{maxSize && (
								<span>
									{maxFiles ? '' : 'Up to '} {formatBytes(maxSize)}{' '}
									each
								</span>
							)}
						</div>
					)}
				</div>
			)}
			<DropzoneRejections
				fileRejections={fileRejections}
				maxSize={maxSize}
			/>
			<DropzoneFileList />
		</>
	)
}

export default DropzoneContent
